<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Movement Type Details</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
        <tempalte v-slot:item.withAgreedSal="{ item }">
          <v-checkbox :value="item.withAgreedSal"></v-checkbox>
        </tempalte>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/movementTypeDetails";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean,
    },
    withSal: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Code",
        value: "reasonCode",
        sortable: true,
      },
      {
        text: "Description",
        value: "reasonDesc",
        sortable: true,
      },
      {
        text: "With Salary",
        value: "withAgreedSal",
        sortable: true,
      },
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50],
    },
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if (data.length > 0) {
            if (!this.withSal) {
              this.items = data;
            } else {
              var results = data.filter((item) => {
                return item.withAgreedSal == this.withSal;
              });
              this.items = results;
            }
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  },
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>
